import React from "react";

function StatsSkeleton() {
  return (
    <div className="space-y-6">
      <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, index) => (
          <div
            key={index}
            className="h-40 animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10"
          />
        ))}
      </div>

      <div className="grid gap-5 lg:grid-cols-2">
        <div className="h-[380px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
        <div className="h-[380px] animate-pulse rounded-[2rem] bg-slate-200 dark:bg-white/10" />
      </div>
    </div>
  );
}

export default StatsSkeleton;